var _path, _mask, _g, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductViews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 144,
    fill: "none",
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M72 144c39.765 0 72-32.236 72-72S111.765 0 72 0C32.236 0 0 32.236 0 72s32.236 72 72 72z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "cp6wgsc9ja",
    width: 144,
    height: 144,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M72 144c39.765 0 72-32.236 72-72S111.765 0 72 0C32.236 0 0 32.236 0 72s32.236 72 72 72z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cp6wgsc9ja)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#E6E6E6",
    strokeWidth: 2,
    d: "M116.263 32.91h-88.33c-6.652 0-12.044 5.43-12.044 12.127V148.36c0 6.698 5.392 12.128 12.044 12.128h88.33c6.653 0 12.045-5.43 12.045-12.128V45.037c0-6.698-5.392-12.128-12.045-12.128z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M62.633 60.416H27.502c-1.109 0-2.008.905-2.008 2.021v35.374c0 1.116.9 2.021 2.008 2.021h35.131c1.109 0 2.008-.905 2.008-2.021V62.437c0-1.116-.9-2.021-2.008-2.021zM39.547 111.96H27.502c-1.109 0-2.008.905-2.008 2.022v12.128c0 1.116.9 2.021 2.008 2.021h12.045c1.109 0 2.008-.905 2.008-2.021v-12.128c0-1.117-.9-2.022-2.008-2.022zM59.622 111.96H47.577c-1.109 0-2.008.905-2.008 2.022v12.128c0 1.116.9 2.021 2.008 2.021h12.045c1.109 0 2.007-.905 2.007-2.021v-12.128c0-1.117-.898-2.022-2.007-2.022zM79.697 111.96H67.652c-1.109 0-2.008.905-2.008 2.022v12.128c0 1.116.9 2.021 2.008 2.021h12.045c1.109 0 2.007-.905 2.007-2.021v-12.128c0-1.117-.898-2.022-2.007-2.022zM99.772 111.96H87.727c-1.109 0-2.008.905-2.008 2.022v12.128c0 1.116.9 2.021 2.008 2.021h12.045c1.109 0 2.007-.905 2.007-2.021v-12.128c0-1.117-.898-2.022-2.007-2.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    fillRule: "evenodd",
    d: "M107.802 111.96h10.037v16.171h-10.037c-1.109 0-2.008-.905-2.008-2.021v-12.128c0-1.117.899-2.022 2.008-2.022z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M50.374 48.288H26.498c-.554 0-1.004.453-1.004 1.01v1.517c0 .558.45 1.01 1.004 1.01h23.876c.554 0 1.003-.452 1.003-1.01v-1.516c0-.558-.449-1.01-1.003-1.01zM118.629 47.277h-3.012c-.554 0-1.003.453-1.003 1.011v3.032c0 .558.449 1.01 1.003 1.01h3.012c.554 0 1.003-.452 1.003-1.01v-3.032c0-.558-.449-1.01-1.003-1.01zM110.598 47.277h-3.011c-.554 0-1.004.453-1.004 1.011v3.032c0 .558.45 1.01 1.004 1.01h3.011c.555 0 1.004-.452 1.004-1.01v-3.032c0-.558-.449-1.01-1.004-1.01z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D9D9D9",
    strokeWidth: 2,
    d: "M72 142.989c39.21 0 70.996-31.783 70.996-70.989S111.21 1.01 72 1.01C32.79 1.01 1.004 32.795 1.004 72c0 39.206 31.786 70.989 70.996 70.989z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M94.255 63.794H72.27c-.554 0-1.004.452-1.004 1.01v2.022c0 .558.45 1.01 1.004 1.01h21.985c.555 0 1.004-.452 1.004-1.01v-2.021c0-.559-.45-1.011-1.004-1.011zM116.338 70.869H72.27c-.554 0-1.004.452-1.004 1.01v2.022c0 .558.45 1.01 1.004 1.01h44.068c.554 0 1.004-.452 1.004-1.01v-2.022c0-.558-.45-1.01-1.004-1.01zM81.805 78.954h-9.033c-.832 0-1.506.679-1.506 1.516v3.032c0 .837.674 1.516 1.506 1.516h9.033c.832 0 1.506-.679 1.506-1.516V80.47c0-.837-.674-1.516-1.506-1.516zM91.843 89.061H72.772c-.832 0-1.506.679-1.506 1.516v5.053c0 .838.674 1.516 1.506 1.516h19.07c.832 0 1.507-.678 1.507-1.516v-5.053c0-.837-.675-1.516-1.506-1.516zM115.933 89.061H96.862c-.832 0-1.506.679-1.506 1.516v5.053c0 .838.674 1.516 1.506 1.516h19.071c.831 0 1.506-.678 1.506-1.516v-5.053c0-.837-.675-1.516-1.506-1.516z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductViews);
export default __webpack_public_path__ + "static/media/product-views.e37f7a770ceabf51efb296e87086044b.svg";
export { ForwardRef as ReactComponent };